import axios from 'axios';
import { Toast } from 'antd-mobile';
import qs from 'qs';
import IP from './config';
import cookie from 'react-cookies';
import aes from './../utils/aes'

let baseUrl = IP.host;
axios.defaults.withCredentials = true;
axios.defaults.timeout = 3000000;
let Aes = new aes();
// 加密 encrypt
// 解密 decrypt

const instance = axios.create({
  xsrfCookieName: 'xsrf-token',
  baseURL: baseUrl,
  timeout: 3000000,
  responseType: 'json',
});

instance.interceptors.request.use({
  success(config) {
    return config;
  },
  error: error => {
    return Promise.reject(error);
  },
});

instance.interceptors.response.use(
  function (response) {
    if (response.data.code === 20002 ) {
      Toast.hide()
      Toast.fail(response.data.message)
      // cookie.remove('token', { path: '/' })
      // window.location.href = '/'
    }
    // if (response.data.code === 20009 || response.data.code === 20001) {
    //   cookie.remove('token', { path: '/' })
    //   window.location.href = '/'
    // }
    // 3.其他失败，比如校验不通过等
    return Promise.resolve(response.data);
  },
  err => {
    Toast.fail('系统异常，请联系管理员！');
    return Promise.reject(err);
  }
);

export default {
  get(url, param) {
    return new Promise(resolve => {
      instance({
        method: 'get',
        url,
        params: param,
        headers: { 'x-auth-token': cookie.load("token") },
      }).then(res => {
        res.data = JSON.parse(Aes.decrypt(IP.key,IP.iv,res.data))
        resolve(res);
      });
    }).catch((err) => { console.error(err) });
  },

  // 废弃
  // post(url, param) {
  //   const parameter= Aes.encrypt(IP.key,IP.iv,param)
  //   console.log(parameter)
  //   return new Promise(resolve => {
  //     instance({
  //       method: 'post',
  //       url,
  //       headers: {
  //         'Content-Type': 'application/x-www-form-urlencoded',
  //         'x-auth-token': cookie.load("token")
  //       },
  //       data: parameter,
  //     }).then(res => {
  //       res.data = JSON.parse(Aes.decrypt(IP.key,IP.iv,res.data))
  //       resolve(res);
  //     }).catch((err) => { console.error(err) });
  //   });
  // },

  // 所有post改成jsonpost
  post(url, param) {
    const parameter= Aes.encrypt(IP.key,IP.iv,param)
    return new Promise(resolve => {
      instance({
        method: 'post',
        url,
        headers: {
          'Content-Type': 'application/json',
          'x-auth-token': cookie.load("token")
        },
        data: parameter,
      }).then(res => {
        res.data = Aes.decrypt(IP.key,IP.iv,res.data)
        resolve(res);
      }).catch((err) => { console.error(err) });
    });
  },

  jsonPost(url, param) {
    return new Promise(resolve => {
      instance({
        method: 'post',
        url,
        headers: {
          'Content-Type': 'application/json',
          'x-auth-token': cookie.load("token")
        },
        data: param,
      }).then(res => {
        resolve(res);
      }).catch((err) => { console.error(err) });
    });
  },

  upload(url, param) {
    return new Promise((resolve) => {
      instance({
        method: 'post',
        url,
        headers: { 'Content-Type': 'multipart/form-data', 'x-auth-token': cookie.load("token") },
        data: param
      }).then(res => {
        res.data = JSON.parse(Aes.decrypt(IP.key,IP.iv,res.data))
        resolve(res)
      }).catch(err => {
        console.error(err)
      })
    })
  },

  export(url, param, fileName) {
    return new Promise(resolve => {
      instance({
        method: 'get',
        url,
        params: param,
        responseType: 'blob',
      })
        .then(res => {
          const blob = new Blob([res.data], { type: 'application/vnd.ms-excel' });
          const linkNode = document.createElement('a');
          linkNode.download = fileName; // a标签的download属性规定下载文件的名称
          linkNode.style.display = 'none';
          linkNode.href = URL.createObjectURL(blob); // 生成一个Blob URL
          document.body.appendChild(linkNode);
          linkNode.click(); // 模拟在按钮上的一次鼠标单击
          URL.revokeObjectURL(linkNode.href); // 释放URL 对象
          document.body.removeChild(linkNode);
          // resolve('导出成功');
        })
        .catch(err => {
          console.error(err);
        });
    });
  },
};
